import React, {memo} from 'react';
import Svg, {
  Circle,
  Defs,
  G,
  LinearGradient,
  Mask,
  Path,
  Polygon,
  Rect,
  Stop,
  Use,
} from 'react-native-svg';
import {platformValue} from '../PlatformUtils';

export interface ISvgProps {
  color?: string;
  width?: number;
  height?: number;
}

const getFillColor = (
  color: string | undefined,
  defaultColor: string = '#FFFFFF',
) => (color ? color : defaultColor);

const getWidth = (props: ISvgProps, defaultValue: number = 24) =>
  props.width !== undefined ? `${props.width}px` : `${defaultValue}px`;

const getHeight = (props: ISvgProps, defaultValue: number = 24) =>
  props.height !== undefined ? `${props.height}px` : `${defaultValue}px`;

export const TabHome: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 18)}
      height={getHeight(props, 14)}
      viewBox="0 0 18 14">
      <Path
        fill={getFillColor(props.color)}
        d="M7.75 14c.062 0 .12-.026.172-.078A.239.239 0 0 0 8 13.75v-4h2v4c0 .062.026.12.078.172.052.052.11.078.172.078h5.25a.487.487 0 0 0 .36-.14.487.487 0 0 0 .14-.36V7.313l.469.375c.041.041.099.057.172.046a.294.294 0 0 0 .171-.078l.625-.781a.336.336 0 0 0 .063-.187c0-.063-.031-.115-.094-.157L16 5.375V2.25a.239.239 0 0 0-.078-.172A.239.239 0 0 0 15.75 2h-1a.239.239 0 0 0-.172.078.239.239 0 0 0-.078.172v1.875L9.781.281A1.2 1.2 0 0 0 9 0a1.2 1.2 0 0 0-.781.281L.594 6.531C.53 6.573.5 6.625.5 6.688c0 .062.02.125.062.187l.625.781a.294.294 0 0 0 .172.078c.073.01.13-.005.172-.046L2 7.313V13.5c0 .146.047.266.14.36.094.093.214.14.36.14h5.25zM6.5 12.5h-3V6.063l5.344-4.375c.104-.084.208-.084.312 0L14.5 6.063V12.5h-3v-4a.239.239 0 0 0-.078-.172.239.239 0 0 0-.172-.078h-4.5a.239.239 0 0 0-.172.078.239.239 0 0 0-.078.172v4z"
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const TabFriends: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 20)}
      height={getHeight(props, 16)}
      viewBox="0 0 20 16">
      <Path
        d="M19 6.25V1.563c0-.438-.146-.808-.438-1.11A1.422 1.422 0 0 0 17.5 0h-15c-.417 0-.77.151-1.063.453A1.537 1.537 0 0 0 1 1.563V6.25c.437-.292.937-.48 1.5-.562V1.5h15v4.188c.562.083 1.062.27 1.5.562zm-2 5.375c.687 0 1.276-.245 1.766-.734.49-.49.734-1.078.734-1.766 0-.687-.245-1.276-.734-1.766A2.407 2.407 0 0 0 17 6.625c-.688 0-1.276.245-1.766.734a2.407 2.407 0 0 0-.734 1.766c0 .688.245 1.276.734 1.766.49.49 1.078.734 1.766.734zm-14 0c.687 0 1.276-.245 1.766-.734.49-.49.734-1.078.734-1.766 0-.687-.245-1.276-.734-1.766A2.407 2.407 0 0 0 3 6.625c-.688 0-1.276.245-1.766.734A2.407 2.407 0 0 0 .5 9.125c0 .688.245 1.276.734 1.766.49.49 1.078.734 1.766.734zm7 0c.687 0 1.276-.245 1.766-.734.49-.49.734-1.078.734-1.766 0-.687-.245-1.276-.734-1.766A2.407 2.407 0 0 0 10 6.625c-.688 0-1.276.245-1.766.734A2.407 2.407 0 0 0 7.5 9.125c0 .688.245 1.276.734 1.766.49.49 1.078.734 1.766.734zm7-1.5a.961.961 0 0 1-.703-.297.961.961 0 0 1-.297-.703c0-.27.099-.505.297-.703A.961.961 0 0 1 17 8.125c.27 0 .505.099.703.297a.961.961 0 0 1 .297.703c0 .27-.099.505-.297.703a.961.961 0 0 1-.703.297zm-14 0a.961.961 0 0 1-.703-.297A.961.961 0 0 1 2 9.125c0-.27.099-.505.297-.703A.961.961 0 0 1 3 8.125c.27 0 .505.099.703.297A.961.961 0 0 1 4 9.125c0 .27-.099.505-.297.703a.961.961 0 0 1-.703.297zm7 0a.961.961 0 0 1-.703-.297A.961.961 0 0 1 9 9.125c0-.27.099-.505.297-.703A.961.961 0 0 1 10 8.125c.27 0 .505.099.703.297a.961.961 0 0 1 .297.703c0 .27-.099.505-.297.703a.961.961 0 0 1-.703.297zM5.25 16a.723.723 0 0 0 .531-.219A.723.723 0 0 0 6 15.25c0-.73-.255-1.349-.766-1.86a2.531 2.531 0 0 0-1.859-.765h-.75c-.73 0-1.349.255-1.86.766C.256 13.9 0 14.52 0 15.25c0 .208.073.385.219.531A.723.723 0 0 0 .75 16a.723.723 0 0 0 .531-.219.723.723 0 0 0 .219-.531c0-.313.11-.578.328-.797.219-.219.484-.328.797-.328h.75c.312 0 .578.11.797.328.219.219.328.484.328.797 0 .208.073.385.219.531A.723.723 0 0 0 5.25 16zm14 0a.723.723 0 0 0 .531-.219.723.723 0 0 0 .219-.531c0-.73-.255-1.349-.766-1.86a2.531 2.531 0 0 0-1.859-.765h-.75c-.73 0-1.349.255-1.86.766-.51.51-.765 1.13-.765 1.859 0 .208.073.385.219.531a.723.723 0 0 0 .531.219.723.723 0 0 0 .531-.219.723.723 0 0 0 .219-.531c0-.313.11-.578.328-.797.219-.219.484-.328.797-.328h.75c.312 0 .578.11.797.328.219.219.328.484.328.797 0 .208.073.385.219.531a.723.723 0 0 0 .531.219zm-7 0a.723.723 0 0 0 .531-.219.723.723 0 0 0 .219-.531c0-.73-.255-1.349-.766-1.86a2.531 2.531 0 0 0-1.859-.765h-.75c-.73 0-1.349.255-1.86.766C7.256 13.9 7 14.52 7 15.25c0 .208.073.385.219.531A.723.723 0 0 0 7.75 16a.723.723 0 0 0 .531-.219.723.723 0 0 0 .219-.531c0-.313.11-.578.328-.797.219-.219.484-.328.797-.328h.75c.312 0 .578.11.797.328.219.219.328.484.328.797 0 .208.073.385.219.531a.723.723 0 0 0 .531.219z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const TabYourGames: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 17)}
      height={getHeight(props, 17)}
      viewBox="0 0 17 17">
      <Path
        d="M5.188 2.063H1.813v3.374h3.375V2.063zM1.813.375h3.375c.931 0 1.687.756 1.687 1.688v3.374c0 .932-.756 1.688-1.688 1.688H1.813A1.688 1.688 0 0 1 .125 5.437V2.063c0-.931.756-1.687 1.688-1.687zm3.375 10.688H1.813v3.374h3.375v-3.374zM1.813 9.374h3.375c.931 0 1.687.756 1.687 1.688v3.374c0 .932-.756 1.688-1.688 1.688H1.813a1.688 1.688 0 0 1-1.687-1.688v-3.374c0-.932.756-1.688 1.688-1.688zm9-7.313v3.376h3.374V2.063h-3.374zm-1.688 0c0-.931.756-1.687 1.688-1.687h3.374c.932 0 1.688.756 1.688 1.688v3.374c0 .932-.756 1.688-1.688 1.688h-3.374a1.688 1.688 0 0 1-1.688-1.688V2.063zm3.375 6.75c.468 0 .844.377.844.844v2.25h2.25c.467 0 .844.376.844.844a.842.842 0 0 1-.844.844h-2.25v2.25a.842.842 0 0 1-.844.844.842.842 0 0 1-.844-.844v-2.25h-2.25a.842.842 0 0 1-.844-.844c0-.468.377-.844.844-.844h2.25v-2.25c0-.467.376-.844.844-.844z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const TabNews: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 19)}
      height={getHeight(props, 14)}
      viewBox="0 0 19 14">
      <Path
        d="M17.75 0a.748.748 0 0 0-.75.75v.178L2 5.018V4.75A.748.748 0 0 0 1.25 4a.748.748 0 0 0-.75.75v4.5c0 .416.334.75.75.75S2 9.666 2 9.25v-.269l3.675 1.003a3 3 0 1 0 5.772 1.575L17 13.072v.178c0 .416.334.75.75.75s.75-.334.75-.75V.75a.748.748 0 0 0-.75-.75zM17 11.519 2 7.429v-.857l15-4.09v9.037zM7 11c0-.222.047-.431.134-.619l2.86.778a1.5 1.5 0 0 1-2.99-.162L7 11z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const TabMore: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 16)}
      height={getHeight(props, 14)}
      viewBox="0 0 16 14">
      <Path
        d="M15.031 2.188a.842.842 0 0 0 .844-.844.842.842 0 0 0-.844-.844H.97a.842.842 0 0 0-.844.844c0 .467.376.843.844.843H15.03zm0 5.624a.842.842 0 0 0 .844-.843.842.842 0 0 0-.844-.844H.97a.842.842 0 0 0-.844.844c0 .467.376.843.844.843H15.03zm0 5.625a.842.842 0 0 0 .844-.843.842.842 0 0 0-.844-.844H.97a.842.842 0 0 0-.844.844c0 .467.376.844.844.844H15.03z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const CloseIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 352 512">
      <Path
        fill={getFillColor(props.color)}
        d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
      />
    </Svg>
  );
};

export const PlusIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 512 512">
      <Path
        d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        fill={getFillColor(props.color)}
      />
    </Svg>
  );
};

export const LockIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 45)}
      height={getHeight(props, 51)}
      viewBox="0 0 448 512">
      <G fill="none" fillRule="evenodd">
        <G fill={getFillColor(props.color)} fillRule="nonzero">
          <Path d="M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z" />
        </G>
      </G>
    </Svg>
  );
};

export const ClockIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 13 14">
      <Path
        d="M6.5 13.422a6.104 6.104 0 0 0 3.148-.85 6.363 6.363 0 0 0 2.298-2.299c.567-.964.85-2.014.85-3.148a6.104 6.104 0 0 0-.85-3.148 6.363 6.363 0 0 0-2.298-2.298A6.104 6.104 0 0 0 6.5.829a6.104 6.104 0 0 0-3.148.85 6.363 6.363 0 0 0-2.298 2.298 6.104 6.104 0 0 0-.85 3.148c0 1.134.283 2.184.85 3.148a6.363 6.363 0 0 0 2.298 2.298c.964.567 2.014.85 3.148.85zm0-1.219c-.914 0-1.76-.228-2.54-.685a5.12 5.12 0 0 1-1.853-1.854 4.928 4.928 0 0 1-.685-2.539c0-.914.228-1.76.685-2.539a5.12 5.12 0 0 1 1.854-1.854A4.928 4.928 0 0 1 6.5 2.047c.914 0 1.76.228 2.539.685a5.12 5.12 0 0 1 1.854 1.854c.457.779.685 1.625.685 2.539 0 .914-.228 1.76-.685 2.54a5.12 5.12 0 0 1-1.854 1.853 4.928 4.928 0 0 1-2.539.685zM8.24 9.62l.063-.007a.325.325 0 0 0 .203-.127l.457-.66a.316.316 0 0 0 .063-.228.278.278 0 0 0-.114-.203l-1.701-1.22V3.57a.294.294 0 0 0-.089-.215.294.294 0 0 0-.216-.09h-.812a.294.294 0 0 0-.216.09.294.294 0 0 0-.089.215v4.164c0 .102.042.187.127.254l2.158 1.575c.068.05.144.067.229.05l-.062.007z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const PlayersIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 17 12">
      <Path
        d="M4.875 6.125c.508 0 .982-.127 1.422-.38.44-.255.787-.602 1.04-1.042.255-.44.382-.914.382-1.422 0-.508-.127-.982-.381-1.422-.254-.44-.601-.787-1.041-1.04A2.798 2.798 0 0 0 4.875.437c-.508 0-.982.126-1.422.38-.44.254-.787.601-1.04 1.041-.255.44-.382.914-.382 1.422 0 .508.127.982.381 1.422.254.44.601.787 1.041 1.041.44.254.914.381 1.422.381zm7.312 0a2.35 2.35 0 0 0 1.727-.71 2.35 2.35 0 0 0 .711-1.727 2.35 2.35 0 0 0-.711-1.727 2.35 2.35 0 0 0-1.727-.711 2.35 2.35 0 0 0-1.726.711 2.35 2.35 0 0 0-.711 1.727c0 .677.237 1.252.71 1.726a2.35 2.35 0 0 0 1.727.711zM4.875 4.906c-.44 0-.821-.16-1.143-.482A1.562 1.562 0 0 1 3.25 3.28c0-.44.16-.82.482-1.142a1.562 1.562 0 0 1 1.143-.483c.44 0 .821.161 1.143.483.321.321.482.702.482 1.142 0 .44-.16.821-.482 1.143a1.562 1.562 0 0 1-1.143.482zm7.312 0c-.338 0-.626-.118-.863-.355a1.175 1.175 0 0 1-.355-.863c0-.339.118-.627.355-.864s.525-.355.863-.355c.339 0 .627.118.864.355s.355.525.355.864c0 .338-.118.626-.355.863a1.175 1.175 0 0 1-.864.355zm-3.656 6.906c.339 0 .627-.118.864-.355.236-.237.355-.525.355-.863V9.45a2.8 2.8 0 0 0-.508-1.625 2.48 2.48 0 0 0-1.003-.888 2.99 2.99 0 0 0-1.333-.305c-.304 0-.6.042-.888.127-.39.118-.775.178-1.156.178-.38 0-.757-.06-1.13-.178a3.133 3.133 0 0 0-.888-.127 2.99 2.99 0 0 0-1.333.305c-.415.203-.758.499-1.029.888A2.903 2.903 0 0 0 0 9.451v1.143c0 .338.118.626.355.863s.525.355.864.355H8.53zM15.234 11a.983.983 0 0 0 .724-.292.983.983 0 0 0 .292-.724v-.94c0-.507-.135-.964-.406-1.37a2.165 2.165 0 0 0-.85-.736 2.487 2.487 0 0 0-1.105-.254c-.237 0-.508.042-.813.127-.305.084-.6.127-.889.127-.287 0-.584-.043-.888-.127a3.078 3.078 0 0 0-.813-.127 2.47 2.47 0 0 0-.965.203c.17.169.305.334.407.495.101.16.203.343.304.546.085-.017.178-.026.28-.026.101 0 .27.026.508.077.406.118.795.177 1.167.177.373 0 .762-.059 1.168-.177.237-.051.415-.077.534-.077.203 0 .385.038.546.115a.96.96 0 0 1 .393.342c.136.204.203.424.203.66v.762h-4.469v.813c0 .135-.016.27-.05.406h4.722zm-6.703-.406H1.22V9.45c0-.355.106-.681.317-.977.212-.297.478-.504.8-.622.27-.102.542-.102.812 0a5.014 5.014 0 0 0 1.727.304c.592 0 1.168-.101 1.727-.304.27-.102.541-.102.812 0 .339.118.61.325.813.622.203.296.304.622.304.977v1.143z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const SettingsIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 18)}
      height={getHeight(props, 18)}
      viewBox="0 0 18 18">
      <Path
        fill={getFillColor(props.color)}
        fillRule="nonzero"
        d="M6.75 17.687c1.5.399 3 .399 4.5 0a.808.808 0 0 0 .457-.298.867.867 0 0 0 .176-.545v-1.266c.398-.187.785-.41 1.16-.668l1.09.633a.969.969 0 0 0 .562.105.683.683 0 0 0 .457-.246 8.8 8.8 0 0 0 2.285-3.902.765.765 0 0 0-.052-.527.871.871 0 0 0-.37-.422l-1.09-.633a12.7 12.7 0 0 0 0-1.336l1.09-.633a.871.871 0 0 0 .37-.422.765.765 0 0 0 .052-.527 8.8 8.8 0 0 0-2.285-3.902.683.683 0 0 0-.457-.246.969.969 0 0 0-.562.105l-1.09.633a8.238 8.238 0 0 0-1.16-.668V1.656a.867.867 0 0 0-.176-.545.808.808 0 0 0-.457-.298 8.62 8.62 0 0 0-4.5 0 .808.808 0 0 0-.457.298.867.867 0 0 0-.176.545v1.266c-.398.187-.785.41-1.16.668l-1.09-.633a.969.969 0 0 0-.562-.105.683.683 0 0 0-.457.246A8.8 8.8 0 0 0 .562 7a.765.765 0 0 0 .053.527.871.871 0 0 0 .37.422l1.09.633a12.7 12.7 0 0 0 0 1.336l-1.09.633a.871.871 0 0 0-.37.422.765.765 0 0 0-.053.527 8.8 8.8 0 0 0 2.286 3.902c.117.141.27.223.457.246a.969.969 0 0 0 .562-.105l1.09-.633c.375.258.762.48 1.16.668v1.266c0 .21.059.392.176.545.117.152.27.252.457.298zm3.445-1.511c-.797.14-1.593.14-2.39 0v-1.758c-.68-.258-1.155-.463-1.424-.615-.27-.153-.686-.463-1.248-.932l-1.547.879a7.352 7.352 0 0 1-1.195-2.074l1.546-.88c-.14-.726-.21-1.241-.21-1.546 0-.305.07-.82.21-1.547l-1.546-.879c.28-.75.68-1.441 1.195-2.074l1.547.879c.562-.469.978-.78 1.248-.932.27-.152.744-.357 1.424-.615V2.324a6.826 6.826 0 0 1 2.39 0v1.758c.68.258 1.155.463 1.424.615.27.153.686.463 1.248.932l1.547-.879a7.352 7.352 0 0 1 1.195 2.074l-1.547.88c.141.726.211 1.241.211 1.546 0 .305-.07.82-.21 1.547l1.546.879a7.352 7.352 0 0 1-1.195 2.074l-1.547-.879c-.562.469-.978.78-1.248.932-.27.152-.744.357-1.424.615v1.758zM9 12.625c.937 0 1.734-.328 2.39-.984.657-.657.985-1.453.985-2.391 0-.937-.328-1.734-.984-2.39-.657-.657-1.454-.985-2.391-.985-.938 0-1.734.328-2.39.984-.657.657-.985 1.454-.985 2.391 0 .938.328 1.734.984 2.39.657.657 1.453.985 2.391.985zm0-1.687c-.469 0-.867-.165-1.195-.493a1.627 1.627 0 0 1-.493-1.195c0-.469.165-.867.493-1.195A1.627 1.627 0 0 1 9 7.563c.469 0 .867.164 1.195.492.328.328.492.726.492 1.195 0 .469-.164.867-.492 1.195A1.627 1.627 0 0 1 9 10.938z"
      />
    </Svg>
  );
};

export const ShareIcon: React.FC<ISvgProps> = memo((props) => {
  return platformValue(
    <Svg
      width={getWidth(props, 17)}
      height={getHeight(props, 20)}
      viewBox="0 0 17 20">
      <Path
        d="M8.454 13.165c.223 0 .415-.08.575-.24.16-.16.24-.347.24-.56v-8.31L9.2 2.827l.496.617 1.125 1.196c.144.16.324.241.54.241.2 0 .37-.066.512-.198a.652.652 0 0 0 .212-.498.709.709 0 0 0-.225-.515L9.075.986a.977.977 0 0 0-.31-.217.82.82 0 0 0-.63 0 .977.977 0 0 0-.31.217L5.04 3.67a.709.709 0 0 0-.226.515c0 .2.07.367.21.498.139.132.308.198.507.198.22 0 .403-.08.548-.24l1.124-1.197.497-.623-.07 1.234v8.31c0 .213.08.4.24.56.16.16.355.24.584.24zm4.789 6.679c.913 0 1.604-.234 2.074-.7.47-.468.705-1.152.705-2.051V8.958c0-.901-.235-1.585-.705-2.052-.47-.468-1.161-.701-2.074-.701h-2.375V7.96h2.246c.369 0 .653.096.853.289.2.192.3.484.3.877v7.795c0 .388-.1.679-.3.872-.2.193-.484.29-.853.29H3.786c-.369 0-.652-.097-.85-.29-.197-.193-.296-.484-.296-.872V9.127c0-.393.099-.685.296-.877.198-.193.481-.289.85-.289h2.245V6.205H3.657c-.909 0-1.599.232-2.071.697-.473.465-.709 1.15-.709 2.056v8.135c0 .9.236 1.583.709 2.05.472.467 1.162.7 2.07.7h9.587z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>,
    {
      android: (
        <Svg
          width={getWidth(props, 16)}
          height={getHeight(props, 19)}
          viewBox="0 0 16 19">
          <Path
            d="M12.375 18.25c.937 0 1.734-.328 2.39-.984.657-.657.985-1.453.985-2.391 0-.937-.328-1.734-.984-2.39-.657-.657-1.442-.985-2.356-.985-.914 0-1.7.305-2.355.914L6.609 10.27c.211-.68.211-1.36 0-2.04l3.446-2.144c.656.61 1.441.914 2.355.914.914 0 1.7-.328 2.356-.984.656-.657.984-1.453.984-2.391 0-.937-.328-1.734-.984-2.39C14.109.577 13.312.25 12.375.25c-.938 0-1.734.328-2.39.984C9.327 1.891 9 2.688 9 3.625c0 .352.047.691.14 1.02L5.696 6.789c-.656-.61-1.441-.914-2.355-.914-.914 0-1.7.328-2.356.984C.328 7.516 0 8.313 0 9.25c0 .938.328 1.734.984 2.39.657.657 1.442.985 2.356.985.914 0 1.699-.305 2.355-.914l3.446 2.144c-.094.329-.141.668-.141 1.02 0 .938.328 1.734.984 2.39.657.657 1.453.985 2.391.985zm0-12.937c-.469 0-.867-.165-1.195-.493a1.627 1.627 0 0 1-.493-1.195c0-.469.165-.867.493-1.195a1.627 1.627 0 0 1 1.195-.492c.469 0 .867.164 1.195.492.328.328.492.726.492 1.195 0 .469-.164.867-.492 1.195a1.627 1.627 0 0 1-1.195.493zm-9 5.625c-.469 0-.867-.165-1.195-.493a1.627 1.627 0 0 1-.493-1.195c0-.469.165-.867.493-1.195a1.627 1.627 0 0 1 1.195-.492c.469 0 .867.164 1.195.492.328.328.492.726.492 1.195 0 .469-.164.867-.492 1.195a1.627 1.627 0 0 1-1.195.493zm9 5.624c-.469 0-.867-.164-1.195-.492a1.627 1.627 0 0 1-.493-1.195c0-.469.165-.867.493-1.195a1.627 1.627 0 0 1 1.195-.492c.469 0 .867.164 1.195.492.328.328.492.726.492 1.195 0 .469-.164.867-.492 1.195a1.627 1.627 0 0 1-1.195.492z"
            fill={getFillColor(props.color)}
            fillRule="nonzero"
          />
        </Svg>
      ),
      web: (
        <Svg
          width={getWidth(props, 21)}
          height={getHeight(props, 19)}
          viewBox="0 0 21 19">
          <Path
            d="M9.128 13.75a.627.627 0 0 0 .626-.626c0-.274-.187-.517-.408-.685l-.039-.028a1.09 1.09 0 0 1-.176-.145c-.028-.028-.06-.056-.088-.091l-.084-.102a1.86 1.86 0 0 1-.176-.299 1.95 1.95 0 0 1-.151-.787c0-1.27 1.03-2.303 2.303-2.303h1.627v.004h.563v1.687c0 .622.503 1.125 1.125 1.125h.13c.278 0 .545-.102.752-.288l4.887-4.398c.267-.24.419-.58.419-.939s-.152-.7-.419-.939L15.161.563a1.218 1.218 0 0 0-2.036.907v1.593h-2.25A5.623 5.623 0 0 0 5.25 8.686c0 2.124 1.216 3.484 2.246 4.25a6.858 6.858 0 0 0 1.294.764c.078.035.162.049.25.049h.088zm5.966 4.5a2.53 2.53 0 0 0 2.531-2.531v-2.25a.842.842 0 0 0-.844-.844.842.842 0 0 0-.843.844v2.25a.842.842 0 0 1-.844.844H3.28a.842.842 0 0 1-.844-.844V3.906c0-.467.377-.844.844-.844h2.25a.842.842 0 0 0 .844-.843.842.842 0 0 0-.844-.844h-2.25A2.53 2.53 0 0 0 .75 3.906V15.72a2.53 2.53 0 0 0 2.531 2.531h11.813zM7.12 9.798a3.315 3.315 0 0 1-.183-1.11 3.936 3.936 0 0 1 3.938-3.938h3.375c.31 0 .563-.253.563-.563V2.522l3.726 3.354-3.727 3.354V7.563A.564.564 0 0 0 14.25 7h-3.322A3.99 3.99 0 0 0 7.12 9.798z"
            fill={getFillColor(props.color)}
            fillRule="nonzero"
          />
        </Svg>
      ),
    },
  );
});

export const UploadIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 60)}
      height={getHeight(props, 42)}
      viewBox="0 0 60 42">
      <Path
        d="M48 42c2.187 0 4.203-.531 6.047-1.594a11.674 11.674 0 0 0 4.36-4.36C59.468 34.204 60 32.189 60 30c0-2.875-.906-5.406-2.719-7.594-1.812-2.187-4.094-3.562-6.844-4.125a9.789 9.789 0 0 0 .563-3.28c0-2.5-.875-4.626-2.625-6.376S44.5 6 42 6c-1.813 0-3.469.5-4.969 1.5-1.312-2.25-3.125-4.062-5.437-5.437C29.28.688 26.766 0 24.047 0c-2.719 0-5.235.672-7.547 2.016A14.893 14.893 0 0 0 11.016 7.5 14.673 14.673 0 0 0 9 15v.75c-2.625.938-4.781 2.563-6.469 4.875C.844 22.938 0 25.563 0 28.5c0 2.438.61 4.688 1.828 6.75a13.758 13.758 0 0 0 4.922 4.922C8.812 41.39 11.062 42 13.5 42H48zm-20.25-6h-1.5a2.17 2.17 0 0 1-1.594-.656A2.17 2.17 0 0 1 24 33.75V21.938l-3 3.28c-.438.438-.984.657-1.64.657-.657 0-1.204-.219-1.641-.656l-1.032-1.031a2.17 2.17 0 0 1-.656-1.594c0-.625.219-1.156.656-1.594l8.72-8.625A2.17 2.17 0 0 1 27 11.72a2.17 2.17 0 0 1 1.594.656L37.312 21c.438.438.657.969.657 1.594a2.17 2.17 0 0 1-.657 1.594l-1.03 1.03c-.438.438-.985.657-1.641.657-.657 0-1.204-.219-1.641-.656l-3-3.281V33.75a2.17 2.17 0 0 1-.656 1.594A2.17 2.17 0 0 1 27.75 36z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const CircleCheckMarkIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 16)}
      height={getHeight(props, 16)}
      viewBox="0 0 16 16">
      <Path
        d="M8 15.75a7.513 7.513 0 0 0 3.875-1.047 7.831 7.831 0 0 0 2.828-2.828A7.513 7.513 0 0 0 15.75 8a7.513 7.513 0 0 0-1.047-3.875 7.831 7.831 0 0 0-2.828-2.828A7.513 7.513 0 0 0 8 .25a7.513 7.513 0 0 0-3.875 1.047 7.831 7.831 0 0 0-2.828 2.828A7.513 7.513 0 0 0 .25 8c0 1.396.349 2.688 1.047 3.875a7.831 7.831 0 0 0 2.828 2.828A7.513 7.513 0 0 0 8 15.75zm-1.25-3.5a.416.416 0 0 1-.344-.156l-3.25-3.25A.416.416 0 0 1 3 8.5c0-.146.052-.26.156-.344l.688-.718a.494.494 0 0 1 .718 0L6.75 9.625l4.687-4.687a.494.494 0 0 1 .72 0l.687.718A.416.416 0 0 1 13 6c0 .146-.052.26-.156.344l-5.75 5.75a.416.416 0 0 1-.344.156z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const CircleCheckMarkOutlineIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 16)}
      height={getHeight(props, 16)}
      viewBox="0 0 38 38">
      <Path
        d="M19 .344c3.315 0 6.383.829 9.203 2.486a18.599 18.599 0 0 1 6.717 6.717c1.657 2.82 2.486 5.888 2.486 9.203 0 3.315-.829 6.383-2.486 9.203a18.599 18.599 0 0 1-6.717 6.717c-2.82 1.657-5.888 2.486-9.203 2.486-3.315 0-6.383-.829-9.203-2.486a18.599 18.599 0 0 1-6.717-6.717C1.422 25.133.594 22.065.594 18.75c0-3.315.828-6.383 2.486-9.203A18.599 18.599 0 0 1 9.797 2.83C12.617 1.173 15.685.344 19 .344zm0 3.562c-2.672 0-5.146.668-7.422 2.004a14.969 14.969 0 0 0-5.418 5.418c-1.336 2.276-2.004 4.75-2.004 7.422 0 2.672.668 5.146 2.004 7.422a14.969 14.969 0 0 0 5.418 5.418c2.276 1.336 4.75 2.004 7.422 2.004 2.672 0 5.146-.668 7.422-2.004a14.969 14.969 0 0 0 5.418-5.418c1.336-2.276 2.004-4.75 2.004-7.422 0-2.672-.668-5.146-2.004-7.422a14.969 14.969 0 0 0-5.418-5.418C24.146 4.574 21.672 3.906 19 3.906zm10.39 9.649c.198.198.297.42.297.668a.705.705 0 0 1-.296.593L16.625 27.508c-.198.198-.42.297-.668.297a.705.705 0 0 1-.594-.297L8.61 20.754c-.198-.198-.297-.42-.297-.668 0-.247.1-.445.297-.594l1.707-1.707c.149-.148.347-.222.594-.222s.47.074.668.222l4.379 4.527 10.539-10.464c.148-.149.346-.223.594-.223.247 0 .47.099.668.297l1.633 1.633z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const CircleCrossIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 16)}
      height={getHeight(props, 16)}
      viewBox="0 0 16 16">
      <Path
        d="M8 15.75a7.513 7.513 0 0 0 3.875-1.047 7.831 7.831 0 0 0 2.828-2.828A7.513 7.513 0 0 0 15.75 8a7.513 7.513 0 0 0-1.047-3.875 7.831 7.831 0 0 0-2.828-2.828A7.513 7.513 0 0 0 8 .25a7.513 7.513 0 0 0-3.875 1.047 7.831 7.831 0 0 0-2.828 2.828A7.513 7.513 0 0 0 .25 8c0 1.396.349 2.688 1.047 3.875a7.831 7.831 0 0 0 2.828 2.828A7.513 7.513 0 0 0 8 15.75zm2.297-3.844a.435.435 0 0 1-.266-.093L8 9.75l-2.031 2.063a.457.457 0 0 1-.282.093.338.338 0 0 1-.25-.093l-1.25-1.25a.435.435 0 0 1-.093-.266c0-.094.031-.182.093-.266L6.25 8 4.187 5.969a.457.457 0 0 1-.093-.281c0-.105.031-.188.093-.25l1.25-1.25a.435.435 0 0 1 .266-.094c.094 0 .182.031.266.094L8 6.25l2.031-2.062a.457.457 0 0 1 .281-.094c.105 0 .188.031.25.094l1.25 1.25a.435.435 0 0 1 .094.265.435.435 0 0 1-.094.266L9.75 8l2.062 2.031a.457.457 0 0 1 .094.282.338.338 0 0 1-.094.25l-1.25 1.25a.435.435 0 0 1-.265.093z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const CircleStopWatchIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 14)}
      height={getHeight(props, 16)}
      viewBox="0 0 14 16">
      <Path
        d="M7 16a6.313 6.313 0 0 0 3.266-.875 6.567 6.567 0 0 0 2.359-2.36c.583-.989.875-2.077.875-3.265a6.365 6.365 0 0 0-1.031-3.531l.937-.938a.457.457 0 0 0 .094-.281.338.338 0 0 0-.094-.25l-.906-.875a.297.297 0 0 0-.25-.125.389.389 0 0 0-.281.125l-.844.844A6.475 6.475 0 0 0 8 3.063V2h.875a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265V.375a.362.362 0 0 0-.11-.266A.362.362 0 0 0 8.876 0h-3.75a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109H6v1.094a6.258 6.258 0 0 0-2.797 1.125A6.398 6.398 0 0 0 1.22 6.516 6.406 6.406 0 0 0 .5 9.5c0 1.188.292 2.276.875 3.266a6.567 6.567 0 0 0 2.36 2.359C4.723 15.708 5.811 16 7 16zm.625-5h-1.25a.362.362 0 0 1-.266-.11.362.362 0 0 1-.109-.265v-4.75c0-.083.036-.167.11-.25a.34.34 0 0 1 .265-.125h1.25a.34.34 0 0 1 .266.125c.073.083.109.167.109.25v4.75a.362.362 0 0 1-.11.266.362.362 0 0 1-.265.109z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const ArrowBackAndroid: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 24 24">
      <Path d="M0 0h24v24H0z" fill="none" />
      <Path
        fill={getFillColor(props.color)}
        d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
      />
    </Svg>
  );
};

export const ArrowBackIos: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 24 24">
      <Rect fill="none" height="24" width="24" />
      <Polygon
        fill={getFillColor(props.color)}
        points="17.77,3.77 16,2 6,12 16,22 17.77,20.23 9.54,12"
      />
    </Svg>
  );
};

export const FilterRemoveIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 13 13">
      <G fill={getFillColor(props.color)} fillRule="nonzero">
        <Path
          d="M7.418 18.312c1.047 0 2.016-.261 2.907-.785.89-.523 1.597-1.23 2.12-2.12.524-.891.786-1.86.786-2.907s-.262-2.016-.785-2.906c-.524-.89-1.23-1.598-2.121-2.121-.89-.524-1.86-.785-2.907-.785-1.046 0-2.015.261-2.906.785-.89.523-1.597 1.23-2.12 2.12-.524.891-.786 1.86-.786 2.907s.262 2.016.785 2.906c.524.89 1.23 1.598 2.121 2.121.89.524 1.86.785 2.906.785zm1.723-2.882c-.07 0-.137-.024-.2-.07l-1.523-1.547-1.523 1.546c-.062.047-.133.07-.21.07-.079 0-.142-.023-.188-.07l-.938-.937c-.047-.063-.07-.129-.07-.2 0-.07.023-.136.07-.199L6.106 12.5l-1.547-1.523c-.047-.063-.07-.133-.07-.211 0-.078.023-.141.07-.188l.938-.937c.062-.047.128-.07.199-.07.07 0 .137.023.199.07l1.523 1.547L8.942 9.64c.062-.047.133-.07.21-.07.079 0 .141.023.188.07l.938.937c.047.063.07.129.07.2 0 .07-.023.136-.07.199L8.73 12.5l1.547 1.523c.047.063.07.133.07.211 0 .079-.023.141-.07.188l-.938.937c-.062.047-.129.07-.199.07z"
          transform="translate(-180 -146) translate(0 20) translate(0 104) translate(168 12) translate(11 4)"
        />
      </G>
    </Svg>
  );
};

export const AchievementOutrightIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 30)}
      height={getHeight(props, 24)}
      viewBox="0 0 30 24">
      <Path
        d="M6.75 7.5a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5zM24 7.5A3.75 3.75 0 1 0 24 0a3.75 3.75 0 0 0 0 7.5zM15 15a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm0-2.25a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5zM11.034 15a5.986 5.986 0 0 1-2.03-4.5c0-.356.033-.703.09-1.045A4.956 4.956 0 0 0 7.004 9H5.001A5.003 5.003 0 0 0 0 14.002c0 .548.45.998.998.998h10.036zm17.968 0a1 1 0 0 0 .998-.998C30 11.24 27.76 9 24.998 9h-1.996c-.746 0-1.454.164-2.091.455.06.337.089.689.089 1.045 0 1.79-.787 3.398-2.03 4.5h10.032zm-6.254 9c.69 0 1.252-.558 1.252-1.252a6.25 6.25 0 0 0-6.248-6.248h-5.504A6.25 6.25 0 0 0 6 22.748C6 23.438 6.558 24 7.252 24h15.496zm-1.125-2.25H8.377c.445-1.725 2.01-3 3.871-3h5.504a3.995 3.995 0 0 1 3.871 3z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const AchievementWinnerIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 25)}
      height={getHeight(props, 24)}
      viewBox="0 0 25 24">
      <G fill={getFillColor(props.color)} fillRule="nonzero">
        <Path d="M5.488 8.977a9.72 9.72 0 0 1 5.784-2.902L8.06.727A1.497 1.497 0 0 0 6.777 0H1.653a1.152 1.152 0 0 0-.96 1.79l4.795 7.187zm14.025 0 4.79-7.186c.131-.188.197-.413.197-.638C24.5.516 23.984 0 23.347 0h-5.124c-.525 0-1.012.277-1.284.727l-3.21 5.348a9.72 9.72 0 0 1 5.784 2.902zM8.375 22.895a8.25 8.25 0 1 0 8.25-14.29 8.25 8.25 0 0 0-8.25 14.29zm7.064-3.747a.44.44 0 0 1-.637.464l-2.1-1.106a.447.447 0 0 0-.408 0l-2.1 1.106a.44.44 0 0 1-.638-.464l.403-2.339a.443.443 0 0 0-.126-.389L8.13 14.76a.44.44 0 0 1 .244-.75l2.353-.341a.432.432 0 0 0 .328-.24l1.05-2.127a.438.438 0 0 1 .788 0l1.05 2.128c.06.126.187.22.328.239l2.348.342a.44.44 0 0 1 .244.75l-1.701 1.66a.448.448 0 0 0-.127.388l.403 2.34z" />
      </G>
    </Svg>
  );
};

export const AchievementPerfectIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 22)}
      viewBox="0 0 24 22">
      <G fill={getFillColor(props.color)} fillRule="nonzero">
        <Path d="M10.781 12.5a3.739 3.739 0 0 0 3.703-3.272l.563-4.533a3.73 3.73 0 1 0-7.406-.923l-.563 4.533a3.73 3.73 0 0 0 3.703 4.195zm8.925-.75a3.74 3.74 0 0 0 3.727-3.403l.342-3.769a3.74 3.74 0 0 0-7.453-.675l-.342 3.769a3.743 3.743 0 0 0 3.726 4.078zM3.164 13.986c.82.108 1.58-.478 1.697-1.299l1.5-10.5A1.475 1.475 0 0 0 4.284.631L.91 2.131a1.525 1.525 0 0 0-.787 1.983 1.48 1.48 0 0 0 1.969.755l.923-.408-1.125 7.851a1.474 1.474 0 0 0 1.275 1.674zM10.777 9.5a.733.733 0 0 1-.727-.825l.567-4.533a.733.733 0 1 1 1.453.183l-.567 4.533a.734.734 0 0 1-.726.642zm8.93-.75a.738.738 0 0 1-.737-.806l.342-3.769a.738.738 0 1 1 1.472.131l-.342 3.769a.736.736 0 0 1-.736.675zM1.566 18.5l.144-.014 21-3a1.501 1.501 0 0 0-.422-2.972l-21 3a1.501 1.501 0 0 0 .422 2.972l-.144.014zm10.5 3 .144-.014 10.5-1.5a1.501 1.501 0 0 0-.422-2.972l-10.5 1.5a1.501 1.501 0 0 0 .422 2.972l-.144.014z" />
      </G>
    </Svg>
  );
};

export const AchievementZeroIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 12)}
      height={getHeight(props, 13)}
      viewBox="0 0 160 160">
      <G fill="none" fillRule="evenodd">
        <G fill={getFillColor(props.color)} fillRule="nonzero">
          <G>
            <Path
              d="M98.844 216c2.396 0 4.427-.938 6.093-2.813l60-67.187c8.125 4.375 16.563 5.833 25.313 4.375 9.166-1.25 17.5-5.625 25-13.125 6.458-6.667 11.354-14.479 14.687-23.437 3.333-8.959 4.583-17.709 3.75-26.25-.833-8.959-4.062-16.146-9.687-21.563-5.417-5.625-12.604-8.854-21.563-9.687-8.541-.833-17.291.416-26.25 3.75-8.958 3.333-16.77 8.229-23.437 14.687-7.5 7.5-11.875 15.834-13.125 25-1.458 8.75 0 17.188 4.375 25.313l-67.188 60C74.937 186.729 74 188.76 74 191.156s.833 4.532 2.5 6.406L92.437 213.5c1.875 1.667 4.01 2.5 6.407 2.5z"
              transform="translate(-90 -120) translate(16 64)"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
};

export const AchievementGameWinnerIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 28)}
      height={getHeight(props, 24)}
      viewBox="0 0 28 24">
      <G fill={getFillColor(props.color)} fillRule="nonzero">
        <G>
          <Path d="M18.5 24c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-1.223c-.98 0-1.777-.797-1.777-1.777 0-.918.745-1.837 1.847-2.137 1.87-.516 4.401-1.533 6.478-3.553C25.93 11.484 27.5 8.466 27.5 4.125 27.5 3.502 26.998 3 26.375 3h-4.95c.014-.244.023-.487.033-.74C21.505 1.021 20.492 0 19.25 0H8.75C7.508 0 6.495 1.022 6.542 2.26c.01.248.019.496.033.74h-4.95C1.002 3 .5 3.502.5 4.125c0 4.34 1.57 7.36 3.68 9.408 2.076 2.02 4.608 3.037 6.473 3.553 1.097.305 1.847 1.219 1.847 2.137 0 .98-.797 1.777-1.777 1.777H9.5c-.83 0-1.5.67-1.5 1.5S8.67 24 9.5 24h9zm-9.319-9.816C8.014 13.67 6.8 12.942 5.75 11.92c-1.5-1.458-2.719-3.562-2.953-6.67h3.951c.427 4.223 1.37 7.045 2.433 8.934zm9.642 0c1.065-1.889 2.007-4.71 2.433-8.934h3.957c-.24 3.108-1.458 5.212-2.954 6.67h-.004c-1.05 1.022-2.264 1.749-3.432 2.264z" />
        </G>
      </G>
    </Svg>
  );
};

export const VendorScoreIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 16)}
      height={getHeight(props, 13)}
      viewBox="0 0 16 13">
      <G fill={getFillColor(props.color)} fillRule="nonzero">
        <G>
          <Path d="M11.665 12.875c.845 0 1.57-.604 1.722-1.438l1.25-6.874h.02a1.093 1.093 0 1 0-.876-.438l-2.436 1.95a.876.876 0 0 1-1.329-.293L8.449 2.648A1.092 1.092 0 0 0 7.875.625a1.093 1.093 0 0 0-.574 2.023L5.734 5.782a.876.876 0 0 1-1.329.293L1.97 4.125a1.094 1.094 0 1 0-.875.438h.019l1.25 6.874a1.75 1.75 0 0 0 1.722 1.438h7.58z" />
        </G>
      </G>
    </Svg>
  );
};

export const ShareAvatarIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 48)}
      height={getHeight(props, 48)}
      viewBox="0 0 48 48">
      <linearGradient
        x1="50%"
        y1="1.486%"
        x2="50%"
        y2="100%"
        id="linear-gradient">
        <stop stopColor="#EFEFEF" offset="0%" />
        <stop stopColor="#BBB" offset="100%" />
      </linearGradient>
      <Path
        d="M40 8c13.255 0 24 10.745 24 24S53.255 56 40 56 16 45.255 16 32 26.745 8 40 8zm-3.234 24.5h-.375c-.97 0-1.868.242-2.696.727a5.406 5.406 0 0 0-1.968 1.968 5.225 5.225 0 0 0-.72 2.407l-.007.289v1.359c0 .625.219 1.156.656 1.594.39.389.852.605 1.39.648l.204.008h13.5a2.17 2.17 0 0 0 1.594-.656c.389-.39.605-.852.648-1.39L49 39.25v-1.36c0-.968-.242-1.867-.727-2.695a5.406 5.406 0 0 0-1.968-1.968 5.225 5.225 0 0 0-2.407-.72l-.289-.007h-.375c-1.062.5-2.14.75-3.234.75a7.433 7.433 0 0 1-2.915-.607l-.32-.143zM52 31h-3c-.813 0-1.516.297-2.11.89A6.58 6.58 0 0 1 49.235 34a6.928 6.928 0 0 1 1.118 2.675l.054.325H53.5c.406 0 .758-.148 1.055-.445.26-.26.405-.562.438-.905L55 35.5V34c0-.812-.297-1.516-.89-2.11-.54-.54-1.17-.834-1.891-.883l-.22-.007zm-21 0h-3c-.813 0-1.516.297-2.11.89-.54.54-.834 1.17-.883 1.891L25 34v1.5c0 .406.148.758.445 1.055.26.26.562.406.905.438l.15.007h3.094a6.944 6.944 0 0 1 1.172-3 6.58 6.58 0 0 1 2.343-2.11c-.54-.54-1.17-.834-1.89-.883L31 31zm9-10.5c-.938 0-1.813.234-2.625.703a5.156 5.156 0 0 0-1.922 1.922 5.165 5.165 0 0 0-.703 2.625c0 .938.234 1.813.703 2.625a5.156 5.156 0 0 0 1.922 1.922A5.165 5.165 0 0 0 40 31c.937 0 1.812-.234 2.625-.703a5.156 5.156 0 0 0 1.922-1.922 5.165 5.165 0 0 0 .703-2.625c0-.937-.234-1.812-.703-2.625a5.156 5.156 0 0 0-1.922-1.922A5.165 5.165 0 0 0 40 20.5zm-10.5 3c-.813 0-1.516.297-2.11.89-.593.594-.89 1.298-.89 2.11 0 .813.297 1.516.89 2.11.594.593 1.297.89 2.11.89.812 0 1.516-.297 2.11-.89.593-.594.89-1.297.89-2.11 0-.812-.297-1.516-.89-2.11-.594-.593-1.298-.89-2.11-.89zm21 0c-.813 0-1.516.297-2.11.89-.593.594-.89 1.298-.89 2.11 0 .813.297 1.516.89 2.11.594.593 1.297.89 2.11.89.812 0 1.516-.297 2.11-.89.593-.594.89-1.297.89-2.11 0-.812-.297-1.516-.89-2.11-.594-.593-1.298-.89-2.11-.89z"
        transform="translate(-16 -8)"
        fill="url(#linear-gradient)"
        fillRule="evenodd"
      />
    </Svg>
  );
};

export const LeaderUpArrowIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 10)}
      height={getHeight(props, 14)}
      viewBox="0 0 10 14">
      <Path
        d="M5.375 14a.723.723 0 0 0 .531-.219.723.723 0 0 0 .219-.531V4l2.062 2.031a.705.705 0 0 0 .516.219c.198 0 .38-.073.547-.219l.5-.531a.666.666 0 0 0 .25-.516.666.666 0 0 0-.25-.515L5.531.219A.723.723 0 0 0 5 0a.723.723 0 0 0-.531.219L.25 4.469a.666.666 0 0 0-.25.515c0 .198.083.37.25.516l.5.531a.813.813 0 0 0 .547.219c.198 0 .37-.073.515-.219L3.875 4v9.25c0 .208.073.385.219.531a.723.723 0 0 0 .531.219h.75z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const LeaderDownArrowIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 10)}
      height={getHeight(props, 14)}
      viewBox="0 0 10 14">
      <Path
        d="M5 14a.723.723 0 0 0 .531-.219l4.219-4.25a.666.666 0 0 0 .25-.515.666.666 0 0 0-.25-.516l-.5-.531a.813.813 0 0 0-.547-.219.705.705 0 0 0-.516.219L6.125 10V.75a.723.723 0 0 0-.219-.531A.723.723 0 0 0 5.375 0h-.75a.723.723 0 0 0-.531.219.723.723 0 0 0-.219.531V10L1.812 7.969a.705.705 0 0 0-.515-.219.813.813 0 0 0-.547.219l-.5.531a.666.666 0 0 0-.25.516c0 .198.083.37.25.515l4.219 4.25A.723.723 0 0 0 5 14z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const FollowAddIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 21)}
      height={getHeight(props, 16)}
      viewBox="0 0 21 16">
      <Path
        d="M5.214 7.464a4 4 0 1 0 4-6.928 4 4 0 0 0-4 6.928zm11.5 3.036c.416 0 .75-.334.75-.75v-2h2c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-2v-2a.748.748 0 0 0-.75-.75.748.748 0 0 0-.75.75v2h-2a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h2v2c0 .416.334.75.75.75zM13.286 16a.928.928 0 0 0 .928-.928A5.57 5.57 0 0 0 8.642 9.5H5.786a5.57 5.57 0 0 0-5.572 5.572c0 .512.416.928.928.928h12.144z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const FollowRemoveIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 21)}
      height={getHeight(props, 16)}
      viewBox="0 0 21 16">
      <Path
        d="M5.214 7.464a4 4 0 1 0 4-6.928 4 4 0 0 0-4 6.928zm9.719 2.061a.747.747 0 0 0 1.06 0l1.468-1.469 1.469 1.469a.75.75 0 0 0 1.059-1.06L18.52 6.998l1.469-1.469a.75.75 0 0 0-1.06-1.06l-1.468 1.47-1.469-1.47a.747.747 0 0 0-1.06 0 .747.747 0 0 0 0 1.06l1.47 1.469-1.47 1.469a.75.75 0 0 0 0 1.059zM13.286 16a.928.928 0 0 0 .928-.928A5.57 5.57 0 0 0 8.642 9.5H5.786a5.57 5.57 0 0 0-5.572 5.572c0 .512.416.928.928.928h12.144z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const CompareIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 19)}
      height={getHeight(props, 16)}
      viewBox="0 0 19 16">
      <Path
        d="M2.326 3.732a2 2 0 1 0 2-3.464 2 2 0 0 0-2 3.464zm12 0a2 2 0 1 0 2-3.464 2 2 0 0 0-2 3.464zM3.826 16a1.5 1.5 0 0 0 1.5-1.5v-2.275l-1.488-1.487a1.748 1.748 0 0 1 0-2.475l2-2c.072-.072.15-.138.235-.197A2.495 2.495 0 0 0 4.026 5h-1.4c-1.3 0-2.384.997-2.49 2.294l-.129 1.54a1.999 1.999 0 0 0 1.319 2.05V14.5a1.5 1.5 0 0 0 1.5 1.5h1zm12 0a1.5 1.5 0 0 0 1.5-1.5v-3.616a1.999 1.999 0 0 0 1.319-2.05l-.128-1.54A2.499 2.499 0 0 0 16.026 5h-1.4c-.84 0-1.594.419-2.047 1.066.081.059.163.125.234.196l2 2c.685.685.685 1.791 0 2.476l-1.487 1.487V14.5a1.5 1.5 0 0 0 1.5 1.5h1zm-9.281-3.969a.751.751 0 0 0 1.28-.531v-1h3v.997a.749.749 0 0 0 1.282.531l2-2a.747.747 0 0 0 0-1.06l-2-2a.751.751 0 0 0-1.281.532v1h-3v-.997a.749.749 0 0 0-1.281-.531l-2 2a.747.747 0 0 0 0 1.06l2 2z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const ChatSendIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 24 24">
      <Defs>
        <LinearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="ywi9o4we0a">
          <Stop stopColor={getFillColor(props.color, '#33BBED')} offset="0%" />
          <Stop
            stopColor={getFillColor(props.color, '#445FF0')}
            offset="100%"
          />
        </LinearGradient>
      </Defs>
      <Path
        d="m322.242 39.592 2.977-3.623 5.84 2.447a1.128 1.128 0 0 0 1.547-.854l3.375-20.25c.16-.946-.858-1.63-1.669-1.162l-21.726 12.534a1.126 1.126 0 0 0 .103 2.025l4.983 2.091 13.467-11.869c.258-.23.623.122.403.39L320.25 35.077v3.774c0 1.106 1.336 1.542 1.992.74z"
        transform="translate(-312 -16)"
        fill="url(#ywi9o4we0a)"
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const EditIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      fill="none"
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 16 16">
      <Path
        d="m13.781 1.84.378.379a.747.747 0 0 1 0 1.06l-.909.912-1.44-1.441.909-.91a.747.747 0 0 1 1.06 0h.002zM6.556 8.007 10.75 3.81l1.44 1.441-4.196 4.194a.748.748 0 0 1-.325.19l-1.828.522.522-1.828a.748.748 0 0 1 .19-.325l.003.003zM11.66.781 5.494 6.944a2.233 2.233 0 0 0-.572.972l-.894 3.125a.75.75 0 0 0 .928.928l3.125-.894c.369-.106.703-.303.972-.572l6.166-6.162a2.25 2.25 0 0 0 0-3.182L14.84.781a2.25 2.25 0 0 0-3.182 0zM2.75 2A2.75 2.75 0 0 0 0 4.75v8.5A2.75 2.75 0 0 0 2.75 16h8.5A2.75 2.75 0 0 0 14 13.25v-3.5a.748.748 0 0 0-.75-.75.748.748 0 0 0-.75.75v3.5c0 .69-.56 1.25-1.25 1.25h-8.5c-.69 0-1.25-.56-1.25-1.25v-8.5c0-.69.56-1.25 1.25-1.25h3.5c.416 0 .75-.334.75-.75A.748.748 0 0 0 6.25 2h-3.5z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const ChevronUpIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      fill="none"
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke={getFillColor(props.color)}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m4.5 15.75 7.5-7.5 7.5 7.5"
      />
    </Svg>
  );
};

export const ChevronDownIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      fill="none"
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke={getFillColor(props.color)}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m19.5 8.25-7.5 7.5-7.5-7.5"
      />
    </Svg>
  );
};

export const ChevronRightIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 320 512"
      fill={getFillColor(props.color)}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
      />
    </Svg>
  );
};

export const DeleteAccountIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 640 512"
      fill={getFillColor(props.color)}>
      <Path d="M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z" />
    </Svg>
  );
};

export const LogoutIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 512 512"
      fill={getFillColor(props.color)}>
      <Path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z" />
    </Svg>
  );
};

export const AlarmIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 31 22"
      fill={getFillColor(props.color)}
      fillRule="nonzero">
      <Path d="m3.748.687 2.25 1.5a1.13 1.13 0 0 1 .314 1.561 1.13 1.13 0 0 1-1.56.314l-2.25-1.5a1.13 1.13 0 0 1-.315-1.56A1.13 1.13 0 0 1 3.748.687zm24.75 1.875-2.25 1.5a1.122 1.122 0 0 1-1.56-.314 1.121 1.121 0 0 1 .314-1.56l2.25-1.5a1.122 1.122 0 0 1 1.56.314c.347.52.207 1.214-.314 1.56zM1.625 8h3c.623 0 1.125.502 1.125 1.125s-.502 1.125-1.125 1.125h-3A1.122 1.122 0 0 1 .5 9.125C.5 8.502 1.002 8 1.625 8zm24.75 0h3c.623 0 1.125.502 1.125 1.125s-.502 1.125-1.125 1.125h-3a1.122 1.122 0 0 1-1.125-1.125c0-.623.502-1.125 1.125-1.125zm-2.906 5.25H21.2l-.853-6.844a.75.75 0 0 0-.745-.656h-8.204a.75.75 0 0 0-.745.656L9.8 13.25H7.531l.89-7.12a3.001 3.001 0 0 1 2.977-2.63h8.204a2.998 2.998 0 0 1 2.976 2.63l.89 7.12zm-11.536 0 .572-4.594a.75.75 0 1 1 1.49.188l-.553 4.406h-1.51zM23.75 17H7.25v2.25h16.5V17zm-16.5-2.25h16.5A2.25 2.25 0 0 1 26 17v2.25a2.25 2.25 0 0 1-2.25 2.25H7.25A2.25 2.25 0 0 1 5 19.25V17a2.25 2.25 0 0 1 2.25-2.25z" />
    </Svg>
  );
};

export const PrizeIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 19 24">
      <Path
        fill={getFillColor(props.color)}
        fillRule="nonzero"
        d="M8.145.38a2.607 2.607 0 0 1 2.71 0l.731.445a.393.393 0 0 0 .192.052l.858-.02a2.598 2.598 0 0 1 2.344 1.356l.412.754c.033.061.08.108.14.14l.756.409a2.608 2.608 0 0 1 1.354 2.343l-.019.858c0 .066.015.136.052.192l.445.732c.507.83.507 1.875 0 2.709l-.445.731a.393.393 0 0 0-.052.192l.02.858a2.598 2.598 0 0 1-1.355 2.344l-.755.413a.339.339 0 0 0-.14.14l-.409.76a2.608 2.608 0 0 1-2.343 1.354l-.858-.019a.349.349 0 0 0-.192.052l-.732.445a2.607 2.607 0 0 1-2.709 0l-.731-.445a.393.393 0 0 0-.192-.052l-.858.02a2.598 2.598 0 0 1-2.344-1.356l-.412-.754a.339.339 0 0 0-.141-.14l-.76-.409a2.608 2.608 0 0 1-1.354-2.343l.019-.858a.349.349 0 0 0-.052-.192l-.445-.736a2.607 2.607 0 0 1 0-2.71l.445-.73a.393.393 0 0 0 .052-.193l-.02-.858a2.61 2.61 0 0 1 1.356-2.348l.754-.413a.339.339 0 0 0 .14-.14l.409-.75A2.608 2.608 0 0 1 6.359.858l.858.019A.349.349 0 0 0 7.41.825L8.141.38h.004zm1.538 1.922a.343.343 0 0 0-.366 0l-.731.445c-.427.258-.919.389-1.416.38l-.857-.02a.351.351 0 0 0-.32.184l-.412.754c-.239.436-.6.797-1.036 1.036l-.754.413a.351.351 0 0 0-.183.319l.019.857c.014.497-.122.99-.38 1.416l-.445.731-.961-.586.96.586a.343.343 0 0 0 0 .366l.446.731c.258.427.389.919.38 1.416l-.02.858a.351.351 0 0 0 .184.318l.754.413c.436.239.797.6 1.036 1.036l.413.754a.351.351 0 0 0 .319.183l.857-.019c.497-.014.99.122 1.416.38l.731.445c.113.07.253.07.366 0l.731-.445c.427-.258.919-.389 1.416-.38l.858.02a.351.351 0 0 0 .318-.184l.413-.754c.239-.436.6-.797 1.036-1.036l.754-.413a.351.351 0 0 0 .183-.318l-.019-.858c-.014-.497.122-.99.38-1.416l.445-.731a.343.343 0 0 0 0-.366l-.445-.731a2.644 2.644 0 0 1-.38-1.416l.02-.857a.351.351 0 0 0-.184-.32l-.754-.412c-.436-.239-.797-.6-1.036-1.036l-.413-.754a.351.351 0 0 0-.318-.183l-.858.019a2.603 2.603 0 0 1-1.416-.38l-.731-.445zM6.5 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0zM.561 20.71l1.931-4.59.211.385a4.101 4.101 0 0 0 3.699 2.133l.52-.015.445.272c.375.23.783.394 1.2.493L6.82 23.536a.741.741 0 0 1-.624.455.745.745 0 0 1-.693-.338l-1.514-2.301-2.63.389a.746.746 0 0 1-.802-1.031h.005zm11.625 2.83-1.748-4.148c.417-.098.82-.262 1.195-.492l.445-.272.52.014a4.106 4.106 0 0 0 3.699-2.133l.21-.384 1.932 4.59a.759.759 0 0 1-.098.75.74.74 0 0 1-.703.28l-2.63-.389-1.51 2.307a.75.75 0 0 1-1.317-.117l.005-.005z"
      />
    </Svg>
  );
};

export const CircleSlashIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 24 24">
      <Path
        fill={getFillColor(props.color)}
        fillRule="nonzero"
        d="M18.552 19.645 4.855 5.948A9.703 9.703 0 0 0 2.75 12a9.749 9.749 0 0 0 9.75 9.75 9.703 9.703 0 0 0 6.052-2.105zm1.589-1.589A9.702 9.702 0 0 0 22.25 12a9.749 9.749 0 0 0-9.75-9.75 9.703 9.703 0 0 0-6.052 2.105l13.697 13.697-.004.004zM.5 12a12 12 0 1 1 24 0 12 12 0 0 1-24 0z"
      />
    </Svg>
  );
};

export const ChatBubbleIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 24)}
      viewBox="0 0 24 24"
      fill={getFillColor(props.color)}>
      <Path
        fillRule="evenodd"
        d="M5.337 21.718a6.707 6.707 0 0 1-.533-.074.75.75 0 0 1-.44-1.223 3.73 3.73 0 0 0 .814-1.686c.023-.115-.022-.317-.254-.543C3.274 16.587 2.25 14.41 2.25 12c0-5.03 4.428-9 9.75-9s9.75 3.97 9.75 9c0 5.03-4.428 9-9.75 9-.833 0-1.643-.097-2.417-.279a6.721 6.721 0 0 1-4.246.997Z"
        clipRule="evenodd"
      />
    </Svg>
  );
};

export const VsIcon: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 24)}
      height={getHeight(props, 46)}
      viewBox="0 0 24 46">
      <Defs>
        <Path id="90g1zzy8qa" d="M0 0h17v24H0z" />
        <Path id="321vxxcgzc" d="M0 0h21v46H0z" />
      </Defs>
      <G fill="none" fillRule="evenodd">
        <G transform="translate(7 17)">
          <Mask id="7ipfgm99ab" fill={getFillColor(props.color)}>
            <Use xlinkHref="#90g1zzy8qa" />
          </Mask>
          <Path
            d="M16.772 6.927C17.499 3.377 16.698.01 11.34.01c-1.122 0-2.147.157-3.068.455L3.597 11.094c.672.944 1.756 1.785 3.298 2.685 2.402 1.394 2.996 2.335 2.649 3.935-.285 1.314-1.003 2.353-2.536 2.353-1.578 0-1.831-1.307-1.551-3.206H.244c-.74 3.926.27 7.13 5.86 7.13 5.16 0 8.041-3.046 8.87-6.868.844-3.887-.568-5.712-4.36-7.87-2.227-1.257-2.59-1.94-2.303-3.264.28-1.29.972-2.056 2.146-2.056 1.5 0 1.492 1.384 1.23 2.994h5.085"
            fill={getFillColor(props.color)}
            fillRule="nonzero"
            mask="url(#7ipfgm99ab)"
          />
        </G>
        <G>
          <Mask id="wtnc7fjvpd" fill={getFillColor(props.color)}>
            <Use xlinkHref="#321vxxcgzc" />
          </Mask>
          <Path
            d="M20.949 0a418.703 418.703 0 0 0-5.581 11.309h-4.863l-2.623 6.943c-1.12 2.947-2.38 6.07-3.228 8.842H4.5c.349-2.685.617-5.93.771-8.91l.453-6.793H.044L0 32.397h6.06A421.936 421.936 0 0 0 .765 46 419.673 419.673 0 0 0 20.95 0"
            fill={getFillColor(props.color)}
            fillRule="nonzero"
            mask="url(#wtnc7fjvpd)"
          />
        </G>
      </G>
    </Svg>
  );
};

export const VsIconBubble: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 37)}
      height={getHeight(props, 32)}
      viewBox="0 0 37 32">
      <Path
        d="M18.501 0c1.832 0 3.602.214 5.272.612l.32-.612a252.184 252.184 0 0 0-3.488 6.884h-3.04l-1.639 4.226c-.7 1.794-1.487 3.695-2.017 5.382h-.096c.218-1.634.385-3.61.482-5.423l.282-4.135h-3.55L11 19.72h3.787A252.814 252.814 0 0 0 11.48 28 252.155 252.155 0 0 0 23.853.63C31.46 2.474 37 8.145 37 14.858c0 8.207-8.281 14.857-18.499 14.857-2.68 0-5.224-.457-7.522-1.278-.86.621-2.262 1.471-3.924 2.185C5.32 31.364 3.232 32 1.158 32c-.47 0-.888-.279-1.07-.707a1.13 1.13 0 0 1 .156-1.14l.09-.103.022-.021a8.493 8.493 0 0 0 .448-.507c.297-.358.694-.886 1.099-1.543.722-1.186 1.409-2.743 1.546-4.493C1.281 21.057.002 18.079.002 14.857.002 6.65 8.283 0 18.502 0zm3.962 10.354c-.7 0-1.342.095-1.917.277l-2.923 6.47c.42.574 1.098 1.086 2.061 1.634 1.501.849 1.873 1.422 1.656 2.395-.178.8-.627 1.433-1.585 1.433-.986 0-1.145-.796-.97-1.952h-3.258c-.462 2.39.17 4.34 3.663 4.34 3.224 0 5.026-1.854 5.544-4.18.528-2.366-.355-3.477-2.725-4.79-1.392-.766-1.62-1.181-1.44-1.988.175-.785.608-1.251 1.342-1.251.937 0 .932.842.769 1.822h3.177c.455-2.161-.046-4.21-3.394-4.21z"
        fill={getFillColor(props.color)}
        fillRule="nonzero"
      />
    </Svg>
  );
};

export const MissingUserAvatar: React.FC<ISvgProps> = (props) => {
  return (
    <Svg
      width={getWidth(props, 48)}
      height={getHeight(props, 48)}
      viewBox="0 0 48 48">
      <Defs>
        <Mask id="mask">
          <Circle cx="24" cy="24" r="24" fill="white" />
          <Path
            d="M15.9 18.25a5.26 5.26 0 0 1 2.602-4.547 5.16 5.16 0 0 1 5.2 0 5.26 5.26 0 0 1 2.601 4.547 5.26 5.26 0 0 1-2.6 4.547 5.16 5.16 0 0 1-5.201 0A5.26 5.26 0 0 1 15.9 18.25zM12 32.782c0-4.04 3.243-7.313 7.245-7.313h3.714c4.003 0 7.245 3.273 7.245 7.313 0 .672-.54 1.218-1.207 1.218h-15.79A1.213 1.213 0 0 1 12 32.782zm19.139-13.917a.965.965 0 0 1 1.377 0l1.91 1.928 1.91-1.928a.965.965 0 0 1 1.378 0 .99.99 0 0 1 0 1.39l-1.91 1.928 1.91 1.928a.987.987 0 0 1 0 1.39.968.968 0 0 1-1.378 0l-1.91-1.927-1.91 1.928a.965.965 0 0 1-1.377 0 .99.99 0 0 1 0-1.39l1.91-1.929-1.91-1.927a.987.987 0 0 1 0-1.39z"
            fill="black"
          />
        </Mask>
      </Defs>
      <Circle
        cx="24"
        cy="24"
        r="24"
        fill={getFillColor(props.color)}
        mask="url(#mask)"
      />
    </Svg>
  );
};
